<div class="row mt-3 p-3">
  <div class="col-3 content-block">
    @if (this.vehicleTypes.length > 0) {
      <label>Vehicle Type</label>
      @if (!this.editToggle) {
        <input type="text" class='form-control' readOnly [(ngModel)]='this.tempVehicleType'>
      }
      @if (this.editToggle) {
        <select
          class='form-control'
          [class.is-invalid]='this.vehicleType === -1'
          [class.is-valid]='this.vehicleType > 0'
          (change)='this.changeVehicleType($event)'
          >
          <option value='-1'>Select a Vehicle Type</option>
          @for (item of this.vehicleTypes; track item) {
            <option
              [value]='item.id'
              [selected]='this.vehicleType === item.id'>
              {{ item.name }}
            </option>
          }
        </select>
      }
    }
    @if (this.vehicleType > 0) {
      <label>Vehicle</label>
      @if (!this.editToggle) {
        <input type="text" class='form-control' readOnly [(ngModel)]='this.tempVehicle'>
      }
      @if (this.editToggle) {
        <select
          class='form-control'
          [class.is-invalid]='this.defect.vehicleId === -1'
          [class.is-valid]='this.defect.vehicleId > 0'
          (change)='this.changeVehicle($event)'
          >
          <option value='-1'>Select a Vehicle</option>
          @for (item of this.vehicles; track item) {
            <option
              [value]='item.id'
              [selected]='this.defect.vehicleId === item.id'
              >
              {{ item.registration }}
            </option>
          }
        </select>
      }
    }
  </div>
  <div class="col content-block">
    @if (this.defect.vehicleId > 0) {
      <div class="row">
        <div class="col-4">
          <label for="vehicleCheckArea">Defect Area</label>
          @if (!this.editToggle) {
            <input type="text" class='form-control' readOnly [(ngModel)]='this.tempCheckArea'>
          }
          @if (this.editToggle) {
            <select
              class='form-control'
              [class.is-invalid]='this.defect.vehicleCheckAreaId === -1'
              [class.is-valid]='this.defect.vehicleCheckAreaId > 0'
              (change)='this.changeVehicleCheckArea($event)'
              >
              <option value='-1'>Select a Defect Area</option>
              @for (item of this.checkAreas; track item) {
                <option [value]='item.id' [selected]='this.defect.vehicleCheckAreaId === item.id'>{{ item.name }}</option>
              }
            </select>
          }
        </div>
        <div class="col-4">
          <label for="vehicleCheckArea">Severity</label>
          @if (!this.editToggle) {
            <input type="text" class='form-control' readOnly [(ngModel)]='this.tempSeverity'>
          }
          @if (this.editToggle) {
            <select
              class='form-control'
              [class.is-invalid]='this.defect.vehicleSeverityId === -1'
              [class.is-valid]='this.defect.vehicleSeverityId > 0'
              (change)='this.changeSeverity($event)'
              >
              <option value='-1'>How Severe is the Defect?</option>
              @for (item of this.severities; track item) {
                <option [value]='item.id' [selected]='this.defect.vehicleSeverityId === item.id'>
                  {{ item.severity }} ({{item.notes}})
                </option>
              }
            </select>
          }
        </div>
        <div class="col-4">
          <label for="inspections">Assigned Inspection Intervals</label>
          @if (!this.editToggle) {
            <input type="text" class='form-control' readOnly [(ngModel)]='this.tempInspection'>
          }
          @if (this.editToggle) {
            <select
              class='form-control'
              (change)='this.changeInspection($event)'
              >
              <option value='-1'>Not a Scheduled Inspection Interval</option>
              @for (item of this.inspections; track item) {
                <option [value]='item.vehicleInspectionIntervalId' [selected]='this.defect.vehicleInspectionIntervalsId === item.vehicleInspectionIntervalId'>
                  {{ item.vehicleInspectionInterval.name }} ({{item.vehicleInspectionIntervalId}})
                </option>
              }
            </select>
          }
        </div>
        <div class="col-4">
          <label for="subcontractor">Where is this Defect being Resolved?</label>
          @if (!this.editToggle) {
            <input type="text" class='form-control' readOnly [(ngModel)]='this.tempSubbieToggle'>
          }
          @if (this.editToggle) {
            <select
              class='form-control'
              [class.is-invalid]='this.defect.depotId === -1 && this.defect.workshopSubcontractorsId === -1'
              [class.is-valid]='this.defect.depotId > 0 || this.defect.workshopSubcontractorsId > 0'
              (change)='this.changeTarget($event)'
              >
              <option value='-1' [selected]='this.defect.workshopSubcontractorsId === -1 || this.isSubcontractor === -1'>Select...</option>
              <option value='0' [selected]='this.defect.workshopSubcontractorsId === 0 || this.defect.workshopSubcontractorsId === null || this.isSubcontractor === 0'>In-House</option>
              <option value='1' [selected]='this.defect.workshopSubcontractorsId > 0 || this.isSubcontractor === 1'>Subcontractor</option>
            </select>
          }
        </div>
        @if (this.isSubcontractor === 1) {
          <div class="col-4">
            <label for="inspections">Subcontractors</label>
            @if (!this.editToggle) {
              <input type="text" class='form-control' readOnly [(ngModel)]='this.tempSubcontractor'>
            }
            @if (this.editToggle) {
              <select
                class='form-control'
                [class.is-invalid]='this.defect.depotId === -1 && this.defect.workshopSubcontractorsId === -1'
                [class.is-valid]='this.defect.depotId > 0 || this.defect.workshopSubcontractorsId > 0'
                (change)='this.changeSubcontractor($event)'
                >
                <option value='-1'>Select a Subcontractor</option>
                @for (item of this.subcontractors; track item) {
                  <option [value]='item.id' [selected]='this.subcontractorId === item.id'>
                    {{ item.name }}
                  </option>
                }
              </select>
            }
          </div>
        }
        @if (this.subcontractorId > 0) {
          <div class="col-4">
            <label for="inspections">Subcontractor Depot</label>
            @if (!this.editToggle) {
              <input type="text" class='form-control' readOnly [(ngModel)]='this.tempSubcontractorDepot'>
            }
            @if (this.editToggle) {
              <select
                class='form-control'
                [class.is-invalid]='this.defect.depotId === -1 && this.defect.workshopSubcontractorsId === -1'
                [class.is-valid]='this.defect.depotId > 0 || this.defect.workshopSubcontractorsId > 0'
                (change)='this.changeSubcontractorDepot($event)'
                >
                <option value='-1'>Select a Depot</option>
                @for (item of this.subcontractorDepots; track item) {
                  <option [value]='item.id' [selected]='this.defect.depotId === item.id'>
                    {{ item.name }} {{item.id}}
                  </option>
                }
              </select>
            }
          </div>
        }
        @if (this.isSubcontractor === 0) {
          <div class="col-4">
            <label for="inspections">{{this.companyName}} Depot</label>
            @if (!this.editToggle) {
              <input type="text" class='form-control' readOnly [(ngModel)]='this.tempSubcontractorDepot'>
            }
            @if (this.editToggle) {
              <select
                class='form-control'
                [class.is-invalid]='this.defect.depotId === -1 && this.defect.workshopSubcontractorsId === -1'
                [class.is-valid]='this.defect.depotId > 0 || this.defect.workshopSubcontractorsId > 0'
                (change)='this.changeSubcontractorDepot($event)'
                >
                <option value='-1'>Select a Depot</option>
                @for (item of this.ownDepots; track item) {
                  <option [value]='item.id' [selected]='this.defect.workshopSubcontractorsId === item.id'>
                    {{ item.name }} {{item.city}}
                  </option>
                }
              </select>
            }
          </div>
        }
        <div class="col-4">
          <label>Book For Date (ignore if not for specific date)</label>
          <input [readOnly]='!this.editToggle' type="date" class='form-control' [(ngModel)]='this.defect.bookedFor'>
        </div>
        <div class="col-6">
          <label>Description</label>
          <textarea
            class='form-control'
            [readOnly]='!this.editToggle'
            [class.is-invalid]='this.defect.description === "" || this.defect.length === 0'
            [class.is-valid]='this.defect.description.length > 0'
            [(ngModel)]='this.defect.description'>
          </textarea>
        </div>
        <div class="col-6">
          <label>PO Numbers</label>
          <textarea
            class='form-control'
            [readOnly]='!this.editToggle'
            [(ngModel)]='this.defect.poNumber'>
          </textarea>
        </div>
      </div>
    }
  </div>
</div>
<!--
bookedFor: string = '';
workshopSubcontractorsId: number = -1;
depotId: number = -1; -->
